import { select, parseData } from "@assets/scripts/utils";
import { isMobile } from "@assets/scripts/responsive";

export default function animateBlock(selector, options = {}) {
    const elements = select(selector)

    elements.forEach(element => {
        const params = parseData(element, 'data-animate') || {}
        params.delay = isMobile() ? 0 : params.delay

        function go() {
            setTimeout(() => {
                element.classList.add('animated')
            }, params.delay * 1000)
        }

        new Waypoint({
            element,
            handler (dir) {
                if(dir !== 'down') return
                go()
                this.destroy()
            },
            offset: '80%'
        })
    })
}
